<app-header></app-header>

<!-- preloader -->
<div [hidden]="isloader" class="preloader">
    <div class="preloader_block">
      <img src="assets/images/preloader.gif">
    </div>
</div>

<!-- Slider start -->
<!-- <div class="ak_page-header" [ngStyle]="{'background-image': 'url(' + banner + ')'}">
    <div class="container">
        <div class="box">
            <h2>{{title}}</h2>
        </div>
    </div>
</div> -->
<!--/ Slider end -->

<section class="test-view-page" style="margin-top: 80px;">
    <div class="container">
        <h4>Shipping & Delivery Policy</h4>
   
        <p style="margin-top:15px;">Last updated on {{todayDate}}</p>

        <p>Shipping is not applicable for business</p>

        <div class="logo-icon-head">
            <a routerLink="/" class="logo"><img width="{{imgWidth}}" height="{{imgHeight}}" src="assets/images/{{logo}}" class="img-responsive"></a>
          </div>
    </div>
</section>

<app-footer></app-footer>
